<div class="sharer">
  <a
  (click) = "onCliskSocials('facebook')"
    data-test="file-social-fb"
    class="icon__social__file"
    [ngClass]="
        isSharedOpen ? 'icon__social__file--active': 'icon__social__file--inactive'
      "
      [ngStyle]="{'transition-delay': isSharedOpen ? '0.3s': '0.1s'}"
    >
    <span
      class="icon icon-social-facebook-no-circle icon--shrink--no-circle icon-no-circle"
    ></span>
  </a>

  <a
  (click) = "onCliskSocials('twitter')"
    data-test="file-social-tw"
    class="icon__social__file"
    [ngClass]="
        isSharedOpen ? 'icon__social__file--active': 'icon__social__file--inactive'
      "
      [ngStyle]="{'transition-delay': isSharedOpen ? '0.2s': '0.2s'}"
    >
    <span
      class="icon icon-social-twitter-no-circle icon--shrink--no-circle icon-no-circle"
    ></span>
  </a>

  <a
  (click) = "onCliskSocials('email')"
    data-test="file-social-mail"
    class="icon__social__file"
    [ngClass]="
        isSharedOpen ? 'icon__social__file--active': 'icon__social__file--inactive'
      "
      [ngStyle]="{'transition-delay': isSharedOpen ? '0.1s': '0.3s'}"
    >
    <span
      class="icon icon-social-mail-no-circle icon--shrink--no-circle icon-no-circle "
    ></span>
  </a>

  <a
    (click)="onClickToggleShare()"
    data-test="file-social-share" >
    <span
    class="icon icon-social-share-no-circle icon__opener  icon-no-circle"
    [ngClass]="
      isSharedOpen ? 'icon__opener--active': 'icon__opener--inactive'
    "
    ></span>
  </a>
</div>

